import { Views } from "@/views";
import { RouteRecordRaw } from "vue-router";

export const unauthenticated: Array<RouteRecordRaw> = [
  {
    path: "/",
    alias: "/home",
    name: "home",
    component: Views.Landing,
    meta: { topbarCollapse: true },
  },
  {
    path: "/sign-in",
    name: "sign-in",
    component: Views.Login,
    meta: { auth: false },
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: Views.ForgotPassword,
    meta: { auth: false },
  },
  {
    path: "/new-password/:id",
    name: "new-password",
    component: Views.NewPassword,
  },
  {
    path: "/signup",
    name: "sign-up",
    component: Views.SignUp,
    meta: { auth: false },
  },
  {
    path: "/signup/:id",
    name: "sign-up-complete",
    component: Views.SignUpComplete,
  },
];
